module.exports = __webpack_public_path__ + "static/media/sc2.22494334.mp4";